import { Tooltip, TooltipContent, TooltipTrigger } from '@/components-new/tooltip/tooltip';

export const BrandGenericStatusIndicator = ({ brandGenericStatus, licenseType }: BrandGenericStatusIndicatorProps) => {
  if (brandGenericStatus === undefined || licenseType === undefined) {
    return <>&mdash;</>;
  }

  let status;
  if (brandGenericStatus === 'Brand') {
    status = 'Brand';
  } else if (brandGenericStatus === 'Generic' && licenseType === 'AG') {
    status = 'Authorized Generic';
  } else {
    status = 'Generic';
  }

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <span>{status}</span>
      </TooltipTrigger>
      <TooltipContent>License Type: {licenseType}</TooltipContent>
    </Tooltip>
  );
};

type BrandGenericStatusIndicatorProps = {
  brandGenericStatus?: 'Brand' | 'Generic';
  licenseType?: string;
};
